import styled from 'styled-components';
import { Spacer } from '@lux/tokens';
import { OpenCampaignCard } from '@browsing/campaign';
import { PlusExclusiveCampaign } from '../../plus';

export const Container = styled.div`
    z-index: 1;
    position: relative;
    overflow: visible;
`;

export const GridWrapper = styled.ul<{ columnCount?: number }>`
    width: 100%;
    display: grid;
    gap: ${({ columnCount }) => (columnCount === 1 ? `${Spacer.SM} 0` : Spacer.M)};
    position: relative;
    grid-template-columns: ${({ columnCount }) =>
        columnCount === 1 ? '100%' : `repeat(${columnCount}, 1fr)`};
`;

export const StyledOpenCampaignCard = styled(OpenCampaignCard)<{
    $colSpan: number;
    $rowSpan: number;
}>`
    grid-column: span ${({ $colSpan }) => $colSpan};
    grid-row: span ${({ $rowSpan }) => $rowSpan};
`;

export const StyledPlusExclusiveCampaign = styled(PlusExclusiveCampaign)<{
    $colSpan: number;
    $rowSpan: number;
}>`
    grid-column: span ${({ $colSpan }) => $colSpan};
    grid-row: span ${({ $rowSpan }) => $rowSpan};
`;
